export enum EFormularTypes {
  FORMULAR = 'FORMULAR', TEXTMODUL = 'TEXTMODUL'
}
